import moment from "moment";
import { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { IoTrashBinOutline, IoTrashBinSharp } from "react-icons/io5";
import { MdOutlineSimCardDownload, MdSimCardDownload } from "react-icons/md";
import {
  PiSortAscendingFill,
  PiSortAscendingLight,
  PiSortDescending,
  PiSortDescendingFill,
} from "react-icons/pi";
import { useAuth } from "../../context/auth";
import { useNotificationContext } from "../../context/notifications";
import SortFunctions from "../../utils/sortArrays";
import NotificationsItems from "./items";

const Notifications = () => {
  const { authToken } = useAuth();
  const {
    notifications,
    setShowNotification,
    removeNotification,
    showNotification,
  } = useNotificationContext();

  const [hoverDelete, setHoverDelete] = useState(false);
  const [hoverDownload, setHoverDownload] = useState(false);
  const [hoverSort, setHoverSort] = useState(false);
  const [sortAsc, setSortAsc] = useState(true);

  const iconSize = 17;

  const removeAll = () => {
    notifications.forEach((item) => {
      removeNotification(item.key);
      setShowNotification(false);
    });
  };

  const buildText = () => {
    const lines: string[] = [];
    lines.push("Download de Alertas");
    lines.push(
      `Extraído por ${authToken?.nome}, em ${moment().format("DD/MM/YYYY [às] HH:mm")}h`
    );
    lines.push("");
    notifications.forEach((item, index) => {
      lines.push(
        `${(index + 1).toString().padStart(5, "0")} | ${moment(item.date).format("DD/MM/YYYY HH:mm:ss")} | ${item.header.padEnd(30, " ")} | ${item.variant ? item.variant.padEnd(10, " ") : String(" ").repeat(10)} | ${item.message}`
      );
    });
    lines.push("");
    lines.push(`Total de alertas: ${notifications.length}`);

    return lines.join("\n");
  };

  const downloadnotifications = () => {
    const blob = new Blob([buildText()], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `notifications_${moment().unix()}.txt`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <Offcanvas
        //data-bs-theme="dark"
        //backdropClassName="text-bg-dark"
        show={showNotification}
        onHide={setShowNotification}
        scroll
      >
        <Offcanvas.Header closeButton style={{ backgroundColor: "#767aef" }}>
          <Offcanvas.Title style={{ color: "white" }}>
            Notificações e Alertas ({notifications.length})
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                fontSize: "12px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="button mx-1"
                onMouseOverCapture={() => {
                  setHoverDelete(true);
                }}
                onMouseLeave={() => {
                  setHoverDelete(false);
                }}
                onClick={removeAll}
              >
                {!hoverDelete ? (
                  <IoTrashBinOutline size={iconSize} />
                ) : (
                  <IoTrashBinSharp size={iconSize} />
                )}
                <span className="ms-1">Limpar</span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="button mx-1"
                onMouseOverCapture={() => {
                  setHoverDownload(true);
                }}
                onMouseLeave={() => {
                  setHoverDownload(false);
                }}
                onClick={downloadnotifications}
              >
                {!hoverDownload ? (
                  <MdOutlineSimCardDownload size={iconSize} />
                ) : (
                  <MdSimCardDownload size={iconSize} />
                )}
                <span className="ms-1">Download</span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                onClick={() => {
                  setSortAsc(!sortAsc);
                }}
                className="button mx-1"
                onMouseOverCapture={() => {
                  setHoverSort(true);
                }}
                onMouseLeave={() => {
                  setHoverSort(false);
                }}
              >
                {!hoverSort ? (
                  sortAsc ? (
                    <PiSortAscendingLight size={iconSize} />
                  ) : (
                    <PiSortDescending size={iconSize} />
                  )
                ) : !sortAsc ? (
                  <PiSortDescendingFill size={iconSize} />
                ) : (
                  <PiSortAscendingFill size={iconSize} />
                )}
                <span className="ms-1">
                  Status ({sortAsc ? "Crescente" : "Decrescente"})
                </span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ backgroundColor: "#f2f2f2" }}>
          <NotificationsItems
            messages={
              sortAsc
                ? notifications.sort((a, b) =>
                    new SortFunctions(a.variant, b.variant).sortStrAsc()
                  )
                : notifications.sort((a, b) =>
                    new SortFunctions(a.variant, b.variant).sortStrDesc()
                  )
            }
            remove={(e) => removeNotification(e)}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Notifications;
